<div class="row mt-4">
  <div class="col-md-12">
    <mat-card class="property-card">
      <!-- Title & Subtitle on the Left -->
      <div class="mat-card-group">
        <mat-card-title class="card-heading">Valuation</mat-card-title>
      </div>

      <mat-card-content>
        <div class="row">
          <div class="col-md-6">
            <table cellpadding="5" class="table table-bordered valuation">
              <thead>
                <tr>
                  <th>Fair Market Value</th>
                  <th class="value market">
                    $
                    {{
                      homeValue?.selectedValue
                        ? (homeValue?.selectedValue | number)
                        : homeValue?.avm?.value
                        ? (homeValue.avm.value | number)
                        : '--'
                    }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Mortgage Payoff</td>
                  <td class="value">${{ reportValuationDetails?.titleInsuranceFee | number }}</td>
                </tr>
                <tr>
                  <td>Broker Commissions (6%)</td>
                  <td class="value">${{ reportValuationDetails?.brokerCommission | number }}</td>
                </tr>
                <tr>
                  <td>Home Warranty Policy</td>
                  <td class="value">${{ reportValuationDetails?.homeWarrantyFee | number }}</td>
                </tr>
                <tr>
                  <td>Document Preparation</td>
                  <td class="value">${{ reportValuationDetails?.recordingFee | number }}</td>
                </tr>
                <tr>
                  <td>Transfer Tax</td>
                  <td class="value">${{ reportValuationDetails?.transferTax | number }}</td>
                </tr>
                <tr>
                  <td><b>Total Closing Payoffs &amp; Expenses</b></td>
                  <td class="value low">${{ cutoffs | number }}</td>
                </tr>
              </tbody>
              <tfoot *ngIf="cmaViewDetails?.reportCategory != 'smartReport'">
                <tr>
                  <td>Estimated Net Proceeds</td>
                  <td class="high value">${{ reportValuationDetails?.netProceeds | number }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="col-md-6">
            <div
              *ngIf="
                !homeValue?.selectedValue ||
                (homeValue.selectedValue >= homeValue?.avm?.lowValue &&
                  homeValue.selectedValue <= homeValue?.avm?.highValue)
              "
              class="fair-value"
            >
              <b>Fair Market Value Range:</b>&nbsp; ${{ homeValue?.avm?.lowValue | number }}&nbsp; - &nbsp;${{
                homeValue?.avm?.highValue | number
              }}
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
